export default __webpack_public_path__ + "static/media/error_products.68582252.svg";